<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><img alt="images" src="images/f005-01.jpg" width="80%"/></p>
<p class="caption">A notable feature of the original Norman chancel arch of St John the Baptist’s church at Wales is a smiling head with circular eyes.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 10_chapter015.vue?55c30c2b